






















import { BookComponents } from '../../components'
import { bookGoodsModelProvider } from '../model'
import { defineClassComponent } from '@/hooks'

export default defineClassComponent(
  {
    components: BookComponents,
  },
  () =>
    class {
      bookGoodsModel = bookGoodsModelProvider.inject()
    },
)
